import { useEffect } from "react";

const HideHelo = () => {

  let chatBot = document.getElementById("omni-chat-web");

  useEffect(() => {
    if (chatBot) {
      chatBot.style.display = "none";
    } else {
      console.log("div omni-chat-web não foi localizado");
    }

    return () => {
      if (chatBot) chatBot.style.display = "";
    }
  }, [])

  return <></>
}

export default HideHelo;